"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var LogoAndName_1 = __importDefault(require("atomicComponents/molecules/Image/LogoAndName"));
var LastCell_1 = __importDefault(require("atomicComponents/molecules/Table/LastCell"));
var OwnerSelect_1 = __importDefault(require("atomicComponents/organisms/Autocomplete/OwnerSelect"));
var Money_1 = __importDefault(require("components/Money"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_2 = require("utils/hooks");
var CompanyTeamsSelect_1 = __importDefault(require("./CompanyTeamsSelect"));
var InvalidSpendToggle_1 = __importDefault(require("./InvalidSpendToggle"));
var RenewalDetails_1 = __importDefault(require("./RenewalDetails"));
var ServiceCell_1 = __importDefault(require("./styles/ServiceCell"));
var ServiceDetails = function (_a) {
    var item = _a.item, onClickRow = _a.onClickRow, isPartialView = _a.isPartialView, isAdmin = _a.isAdmin;
    var onClick = function () { return onClickRow === null || onClickRow === void 0 ? void 0 : onClickRow(item); };
    var confirm = (0, hooks_1.useConfirm)();
    var _b = __read((0, hooks_2.useSubmitter)('service_stats', item.id), 2), updateServiceStat = _b[0], isSending = _b[1];
    var toggleVisibility = function () { return __awaiter(void 0, void 0, void 0, function () {
        var newValue, isDelete;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newValue = !item.isSoftDelete;
                    if (!newValue) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirm('Are you sure that you want to delete this tool? You can always revert this from the view Deleted tools.', '', 'red', 'Yes, delete')];
                case 1:
                    isDelete = _a.sent();
                    if (!isDelete)
                        return [2 /*return*/];
                    _a.label = 2;
                case 2:
                    updateServiceStat({ isSoftDelete: newValue });
                    return [2 /*return*/];
            }
        });
    }); };
    var toggleValidity = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            updateServiceStat({ isHudledInvalid: !item.isHudledInvalid });
            return [2 /*return*/];
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(ServiceCell_1.default, __assign({ width: 214, sx: { pl: 0.5 }, flex: "none", onClick: onClick, position: "relative" }, { children: [(0, jsx_runtime_1.jsx)(LogoAndName_1.default, { brand: item.service, size: "md_table" }), (isAdmin && (item === null || item === void 0 ? void 0 : item.isHudledInvalid)) && ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ component: "span", position: "absolute", top: 16, left: 40 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", color: "red.main", component: "small" }, { children: "Invalid Spend" })) })))] })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ width: 110, textAlign: "right", flex: "none", onClick: onClick, hidden: isPartialView, sx: { paddingRight: 1.5 } }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: (item === null || item === void 0 ? void 0 : item.calculatedAnnualSpend) || 0, isRounded: true }) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ hidden: isPartialView, onClick: onClick, width: 165, sx: { paddingLeft: 2 } }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ onClick: function (e) { return e.stopPropagation(); } }, { children: (0, jsx_runtime_1.jsx)(OwnerSelect_1.default, { serviceStat: item }) })) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ hidden: isPartialView, onClick: onClick, width: 165, sx: { paddingLeft: 1.125 } }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ onClick: function (e) { return e.stopPropagation(); } }, { children: (0, jsx_runtime_1.jsx)(CompanyTeamsSelect_1.default, { item: item }) })) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ pr: 0, textAlign: "right", hidden: isPartialView, onClick: onClick, width: 180 }, { children: (0, jsx_runtime_1.jsx)(RenewalDetails_1.default, { serviceStat: item }) })), (0, jsx_runtime_1.jsx)(LastCell_1.default, __assign({ hidden: isPartialView }, { children: (item === null || item === void 0 ? void 0 : item.isSoftDelete)
                    ? (0, jsx_runtime_1.jsx)(IconButtons_1.UndoButton, { outlined: true, onClick: toggleVisibility, disabled: isSending, sx: { visibility: 'hidden' } })
                    : (0, jsx_runtime_1.jsx)(IconButtons_1.RemoveButton, { outlined: true, onClick: toggleVisibility, disabled: isSending, sx: { visibility: 'hidden' } }) })), isAdmin && ((0, jsx_runtime_1.jsx)(InvalidSpendToggle_1.default, { isHudledInvalid: item === null || item === void 0 ? void 0 : item.isHudledInvalid, isPartialView: isPartialView, onClick: toggleValidity, isSending: isSending }))] }));
};
exports.default = ServiceDetails;
